import { Expose } from 'class-transformer';
import { SpecialNeedEnum } from '../../../guest-management/enum/special-need.enum';

export class EditGuestResponseDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'full_name' })
  fullName: string;
  @Expose({ name: 'phone' })
  phone: string;
  @Expose({ name: 'email' })
  email: string;
  @Expose({ name: 'arriving_on' })
  arrivingOn: number;
  @Expose({ name: 'need_escort' })
  needEscort: boolean;
  @Expose({ name: 'allow_parking' })
  allowParking: boolean;
  @Expose({ name: 'with_car' })
  withCar: boolean;
  @Expose({ name: 'license_number' })
  licenseNumber: string;
  @Expose({ name: 'user_id' })
  userId: number;
  @Expose({ name: 'building_id' })
  buildingId: number;
  @Expose({ name: 'building' })
  building: any;
  @Expose({ name: 'user' })
  user: any;
  @Expose({ name: 'floor_id' })
  floor_id: number;
  @Expose({ name: 'floor' })
  floor: any;
  @Expose({ name: 'company_id' })
  companyId: number;
  @Expose({ name: 'location_id' })
  locationId: number;
  @Expose({ name: 'special_need' })
  specialNeed: SpecialNeedEnum;
}
